import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { Flex, Text, InputGroup, Input, InputRightElement, Alert, AlertIcon } from '@chakra-ui/react';

import * as FiIcons from 'react-icons/fi';

import Pagination from 'src/components/shared/pagination/Pagination';
import Breadcrumbs from 'src/components/shared/breadcrumbs/Breadcrumbs';
import OrdersTable from './Table';

import { getOrders } from 'src/store/orders/ordersSlice';

import { Wrapper } from './Styles';

import theme from '../../global/theme';

const Orders = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const orders = useSelector(state => state.orders);

  const [page, setPage] = useState(1);
  const [query, setQuery] = useState("");

  useEffect(() => {
    dispatch(getOrders({ page, query }));
  }, [dispatch, page, query]);


  return (
    <Wrapper>
      <Breadcrumbs
        currentPage={t('pages.orders.orders')}
        pages={[{ name: `${t('pages.dashboard.dashboard')}`, path: '/' }]}
      />

      {orders.error && (
        <Alert status="error" variant="left-accent" marginBottom={8}>
          <AlertIcon />
          <Text>{orders.error}</Text>
        </Alert>
      )}

      <Flex marginBottom={8} justifyContent="flex-end">
        <InputGroup width="auto">
          <Input auth="auto" type="text" placeholder={t('general.search')}
            bg={theme.light} boxShadow={theme.shadow} color={theme.dark} border="none"
            onChange={(e) => setQuery(e.currentTarget.value)}
          />
          <InputRightElement color={theme.light} children={<FiIcons.FiSearch />} />
        </InputGroup>
      </Flex>

      {orders.itemsCount > 0 ? (
        <OrdersTable
          data={orders.data}
          page={page}
        />
      ) : (
        <Flex textAlign="center" bg={theme.light} boxShadow={theme.shadow} height={200} alignItems="center"
          justifyContent="center" borderRadius={16}>
          <Text fontSize={18} textTransform="capitalize" color="gray.300" fontWeight="bold">
            {t('pages.orders.no_orders')}
          </Text>
        </Flex>
      )}

      <Flex justifyContent="flex-end">
        <Pagination
          page={page}
          itemsCount={orders.itemsCount ?? 0}
          onChange={(page) => setPage(page)}
        />
      </Flex>
    </Wrapper>
  )
}

export default Orders